import axios from 'axios' 
import { BUSCAR_ITINERARIOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export default function buscarItinerarios (codigo, codigoRota, pagina, registrosPorPagina,filtros) {
  if (!codigoRota) {
    codigoRota = 0
  }

  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);

  let url = `${URL}/itinerario/empresa/${codigo}/rota/${codigoRota}/itinerarios/${urlFiltros}`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ITINERARIOS,
        payload: response

      })
  );
}
